export const DESIGN_IDEAS_EMAIL = 'ideas@customink.com';
export const BOOSTER_AUTOSAVE_EMAIL = 'autosave@booster.com';
